import type { QueryClient } from "@tanstack/react-query";
import {
  createRootRouteWithContext,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { useEffect } from "react";
import type { useAuth } from "../features/auth/hooks/useAuth";

interface MyRouterContext {
  auth: ReturnType<typeof useAuth>;
  queryClient: QueryClient;
}

function RootComponent() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    const main = document.getElementById("main-content");
    if (main) main.focus({ preventScroll: true });
  }, [pathname]);

  return <Outlet />;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
});
